import css from './button.scss'

const Button = (props) => {
    let buttonCss = props.style ? `${props.style} ${css.button}` : 'button';
    return (
        <button className={buttonCss} onClick={() => props.onClick()}>
            {props.img ? <img src={props.img} alt={props.name} className={props.avatar ? css.avatar : ""} /> : ""}
            <span>{props.caption}</span>
        </button>
    );
}

export default Button;